module.exports = __webpack_public_path__ + "static/img/accesslist.74439421.png";